import React from "react";

class BG1 extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 139.031 109.562">
        <path
          id="solutSlideBg1"
          d="M534,276c13.481-17.617,106.985-18.21,124-1,15.05,15.222-.48,59.379-29,79-33.091,22.766-68.268,22.211-87,8C524.733,348.9,517.8,297.169,534,276Z"
          transform="translate(-524.844 -262.438)"
          fill="currentColor"
        />
        <path
          id="solutSlideIcon1"
          data-name="Forma 1"
          d="M581.563,320.219a1.406,1.406,0,1,1-1.407,1.406A1.406,1.406,0,0,1,581.563,320.219Zm16.875,0a1.406,1.406,0,1,1-1.407,1.406A1.406,1.406,0,0,1,598.438,320.219ZM590,292a24,24,0,1,0,24,24A24.052,24.052,0,0,0,590,292Zm0,45.188A21.188,21.188,0,1,1,611.187,316,21.212,21.212,0,0,1,590,337.188Zm0-39.469a18.274,18.274,0,0,0-12.188,31.9,1.406,1.406,0,0,0,1.877-2.094,15.5,15.5,0,0,1-5.092-10.115h1.34a1.406,1.406,0,1,0,0-2.812H574.6a15.4,15.4,0,0,1,3.522-8.487l0.944,0.944a1.406,1.406,0,1,0,1.989-1.989l-0.944-.944a15.4,15.4,0,0,1,8.487-3.522v1.342a1.406,1.406,0,0,0,2.812,0V300.6a15.4,15.4,0,0,1,8.487,3.522l-0.944.944a1.406,1.406,0,1,0,1.989,1.989l0.944-.944a15.4,15.4,0,0,1,3.522,8.487h-1.342a1.4,1.4,0,1,0,0,2.8H605.4a15.528,15.528,0,0,1-5.091,10.124,1.406,1.406,0,0,0,1.876,2.094A18.274,18.274,0,0,0,590,297.719Zm1.406,14.3v-4.46a1.406,1.406,0,1,0-2.812,0v4.46A4.219,4.219,0,1,0,591.406,312.023ZM590,317.406A1.406,1.406,0,1,1,591.406,316,1.408,1.408,0,0,1,590,317.406Zm5.625,5.625h-11.25a1.406,1.406,0,0,0-1.406,1.406v5.626a1.406,1.406,0,0,0,1.406,1.406h11.25a1.406,1.406,0,0,0,1.406-1.406v-5.626A1.406,1.406,0,0,0,595.625,323.031Zm-1.406,5.625h-8.438v-2.812h8.438v2.812Z"
          transform="translate(-526 -267)"
          fill="currentColor"
        />
      </svg>
    );
  }
}

export default BG1;
